import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagB = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2056_28810)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
			fill: "#FFBB00"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M4.75924 3.82296H8.82825C9.52443 3.82296 10.0646 4.01901 10.4487 4.4111C10.8408 4.8032 11.0368 5.32333 11.0368 5.97149C11.0368 6.29157 10.9928 6.56364 10.9048 6.7877C10.8248 7.01175 10.7127 7.1958 10.5687 7.33984C10.4327 7.48387 10.2686 7.5919 10.0766 7.66392C9.89252 7.72793 9.69247 7.76394 9.47642 7.77194V7.84396C9.67647 7.84396 9.88452 7.87997 10.1006 7.95199C10.3246 8.02401 10.5287 8.14004 10.7127 8.30008C10.8968 8.45211 11.0488 8.65216 11.1688 8.90023C11.2969 9.14829 11.3609 9.45236 11.3609 9.81245C11.3609 10.1405 11.3049 10.4526 11.1928 10.7487C11.0888 11.0368 10.9408 11.2888 10.7487 11.5049C10.5567 11.7209 10.3286 11.893 10.0646 12.021C9.8005 12.141 9.51243 12.2011 9.20035 12.2011H4.75924V3.82296ZM6.58369 10.6647H8.68422C8.92428 10.6647 9.11233 10.6007 9.24836 10.4726C9.3924 10.3366 9.46441 10.1485 9.46441 9.90848V9.50038C9.46441 9.26032 9.3924 9.07627 9.24836 8.94824C9.11233 8.8122 8.92428 8.74419 8.68422 8.74419H6.58369V10.6647ZM6.58369 7.25581H8.39615C8.63621 7.25581 8.82425 7.1878 8.96029 7.05176C9.09632 6.91573 9.16434 6.72768 9.16434 6.48762V6.12753C9.16434 5.88747 9.09632 5.69943 8.96029 5.56339C8.82425 5.42736 8.63621 5.35934 8.39615 5.35934H6.58369V7.25581Z",
			fill: "#011E38"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2056_28810",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgFlagB;
